import { useLocation } from "react-router-dom";

export const useOnParticipantPage = () => {
  const location = useLocation();
  return (
    location.pathname.includes("/participant/") &&
    !location.pathname.includes("/edit")
  );
};
